/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// ajouter les étapes peu importe le type d'acte au fur et a mesure ici
// L'ordre des valeurs numériques doit refléter l'ordre logique du parcours
// (utilisé tel quel par `AssistantHeader`/`Assistant.handleErrors`, cf.
// `STEPS_BY_TYPE_ACTE` pour la sélection des étapes par type d'acte).
export enum Steps {
  Acte = 0,
  Enfant = 1,
  Parents = 2,
  Mentions = 3,
  // Étapes propres à l'acte de DÉCÈS. Les valeurs ne portent aucun ordre
  // d'affichage — celui-ci vient de `STEPS_BY_TYPE_ACTE[typeActe]`, un tableau
  // ordonné — d'où leur ajout en fin d'énumération, qui ne déplace rien.
  Defunt = 4,
  Declarant = 5,
  // Étapes propres à l'acte de MARIAGE. Même remarque : la valeur ne porte
  // aucun ordre d'affichage, seul `STEPS_BY_TYPE_ACTE` l'établit.
  Conjoint1 = 6,
  ParentsConjoint1 = 7,
  Conjoint2 = 8,
  ParentsConjoint2 = 9,
}

export default Steps;
